import COLOR from "./constants/colors";

const styles = {
  App: {
    fontSize: 20,
  },
};

export default styles;
